export default function AreasServed() {
  const locations = [
    {
      name: 'New York City',
      coverage: 'All 5 boroughs - Manhattan, Brooklyn, Queens, Bronx, Staten Island',
      icon: 'building'
    },
    {
      name: 'Westchester County',
      coverage: 'Yonkers, White Plains, New Rochelle, Mount Vernon, and surrounding areas',
      icon: 'map-pin'
    },
    {
      name: 'Long Island',
      coverage: 'Nassau County & Suffolk County — including Hempstead, Freeport, Babylon, Islip, and Brookhaven',
      icon: 'anchor'
    },
    {
      name: 'New Jersey',
      coverage: 'Northern NJ including Bergen, Hudson, Essex, Passaic, and Union counties',
      icon: 'map'
    },
    {
      name: 'Connecticut',
      coverage: 'Fairfield County including Stamford, Norwalk, Bridgeport, and Danbury',
      icon: 'road-map'
    }
  ];

  return (
    <section id="areas-served" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-gray-500 uppercase tracking-wider text-sm font-medium mb-4">
            WHERE WE SERVE
          </p>
          <h2 className="text-5xl font-bold text-gray-900">
            Tri-State Coverage Area
          </h2>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Map Illustration */}
          <div className="relative">
            <div 
              className="w-full h-96 rounded-2xl shadow-lg bg-cover bg-center"
              style={{
                backgroundImage: `url('https://public.readdy.ai/ai/img_res/137a790359f2fd2ae4728bb3ffa53248.jpg')`
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-white/20 to-transparent rounded-2xl"></div>
            </div>
          </div>

          {/* Location Cards */}
          <div className="space-y-4">
            {locations.map((location, index) => (
              <div 
                key={index}
                className="bg-gray-50 rounded-lg p-6 hover:shadow-md transition-shadow duration-300"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#14B8A6] rounded-lg flex-shrink-0">
                    <i className={`ri-${location.icon}-line text-white text-2xl`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {location.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {location.coverage}
                    </p>
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-check-line text-[#14B8A6] text-2xl"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Banner */}
        <div className="mt-16 bg-[#1e3a5f] rounded-2xl py-6 px-8 text-center">
          <p className="text-white text-lg font-semibold">
            Serving NYC • Long Island • Westchester • NJ • CT — up to 100 miles from NYC • Same-day service available
          </p>
        </div>
      </div>
    </section>
  );
}